import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AdminLogisticPartnerService, LogisticPartnerDetails } from '../../../_services/admin-logistic-partner.service';

@Component({
    selector: 'app-logistic-partner-details',
    templateUrl: './logistic-partner-details.component.html',
    styleUrls: ['./logistic-partner-details.component.css'],
    standalone: false
})
export class LogisticPartnerDetailsComponent implements OnInit, OnDestroy {
    partnerId: string = '';
    partner: LogisticPartnerDetails | null = null;
    loading = false;
    private modalRef: NgbModalRef;

    constructor(
        private adminLogisticPartnerService: AdminLogisticPartnerService,
        private route: ActivatedRoute,
        private router: Router,
        private titleService: Title,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) {
        this.titleService.setTitle('Logistic Partner Details');
    }

    ngOnInit(): void {
        this.partnerId = this.route.snapshot.params['partnerId'];
        if (this.partnerId) {
            this.loadPartnerDetails();
        }
    }

    ngOnDestroy(): void {
        this.titleService.setTitle('');
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    loadPartnerDetails(): void {
        this.loading = true;
        this.adminLogisticPartnerService.getPartnerDetails(this.partnerId).subscribe({
            next: (response) => {
                this.partner = response.data;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.toastr.error('Error loading logistic partner details');
            }
        });
    }

    isCompanyPartner(): boolean {
        return this.partner?.carrierType === 'company';
    }

    isPrivatePartner(): boolean {
        return this.partner?.carrierType === 'private';
    }

    canApprove(): boolean {
        return this.partner?.status === 'COMPLETED' || this.partner?.status === 'REJECTED';
    }

    canReject(): boolean {
        return this.partner?.status === 'COMPLETED' || this.partner?.status === 'VERIFIED';
    }

    openApproveConfirmation(confirmModal: TemplateRef<any>): void {
        this.modalRef = this.modalService.open(confirmModal, { centered: true });
    }

    confirmApprove(): void {
        if (this.modalRef) {
            this.modalRef.close();
        }

        this.adminLogisticPartnerService.approvePartner(this.partnerId).subscribe({
            next: () => {
                this.toastr.success('Logistic partner approved successfully');
                this.router.navigate(['/admin', 'logistic-partners']);
            },
            error: () => {
                this.toastr.error('Error approving logistic partner');
            }
        });
    }

    openRejectModal(): void {
        this.router.navigate(['/admin', 'logistic-partners', this.partnerId, 'reject']);
    }

    goBack(): void {
        this.router.navigate(['/admin', 'logistic-partners']);
    }

    getStatusClass(): string {
        switch (this.partner?.status) {
            case 'PENDING':
                return 'badge bg-warning';
            case 'COMPLETED':
                return 'badge bg-info';
            case 'VERIFIED':
                return 'badge bg-success';
            case 'REJECTED':
                return 'badge bg-danger';
            default:
                return 'badge bg-secondary';
        }
    }
}
